import { PostfixOptions } from 'components/PostfixNew/types';
import React from 'react';

import { PostfixGroupProps, View } from './index.view';

export function PostfixGroup<T extends PostfixOptions>(props: PostfixGroupProps<T>) {
  return <View {...props} />;
}
